import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDeleteProductMutation } from '../services/products.endpoints';

interface ProductDeleteDialogProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  id: string;
}

const ProductDeleteDialog = ({
  open,
  setOpen,
  id,
}: ProductDeleteDialogProps) => {
  const [deleteProduct, { isLoading, error, isSuccess }] =
    useDeleteProductMutation();

  const navigate = useNavigate();

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    if (isSuccess) {
      timer = setTimeout(() => {
        // navigate to home
        navigate('/');
      }, 3000);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [isSuccess, navigate]);

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>Confirm Delete Product</DialogTitle>
      <DialogContent>
        {isSuccess ? (
          <DialogContentText>
            Product successfully deleted. You will be redirected shortly.
          </DialogContentText>
        ) : (
          <DialogContentText>
            Are you sure you want to delete this product? This action cannot be
            undone. Alternatively, you can hide this product from the Edit page.
          </DialogContentText>
        )}
        {error && (
          <Alert severity="error">
            An error occurred while attempting to delete this product.{' '}
            {'status' in error ? error.status : ''}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="secondary"
          disabled={isLoading || isSuccess}
          onClick={() => setOpen(false)}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          disabled={isLoading || isSuccess}
          onClick={() => {
            deleteProduct(id);
          }}
        >
          {isLoading ? <CircularProgress /> : 'Yes, Delete Product'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProductDeleteDialog;
